export const RemoteConfig = {
	url: __API_BACKEND__
};
